/* 
 * @Author: 曹俊杰 
 * @Date: 2022-11-28 11:23:48
 * @Module: 成单表单
 */
  <template>
  <el-dialog :title="type=='add'?'添加成单':type=='revision'?'修改成单':''" :visible.sync="dialogVisible" width="40%" @closed="closed">
    <div style="padding:20px;">
      <el-form size="mini" label-position="top" label-width="120px" :model="form" ref="form">
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item label="单号" prop="number" :rules="{ required: true, message: '单号不能为空'}">
              <el-input v-model="form.number" placeholder="请输入单号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="成单金额" prop="amount" :rules="{ required: true, message: '成单金额不能为空'}">
              <el-input v-model.number="form.amount" placeholder="请输入成单金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName" :rules="{ required: true, message: '客户名称不能为空'}">
              <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName" :rules="{ required: true, message: '项目名称不能为空'}">
              <projectName v-model="form.projectName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成单会员" prop="promoterUuid" :rules="{ required: true, message: '成单会员不能为空'}">
              <inviter v-model="form.promoterUuid" placeholder="请选择成单会员" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目介绍" prop="projectIntro">
              <el-input v-model="form.projectIntro" placeholder="请输入项目介绍" type="textarea" :autosize="{minRows: 4, maxRows: 12}"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="note">
              <el-input v-model="form.note" type="textarea" :autosize="{minRows: 4, maxRows: 12}" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="submit" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>
 <script>
import inviter from "@/views/Promoter/components/form/inviter.vue";
import projectName from "@/views/Deal/components/form/projectName.vue";
export default {
  components: {
    inviter,
    projectName
  },
  data () {
    return {
      type: 'add',
      dialogVisible: false,
      form: {
        dealUuid: null,

        number: null,
        amount: null,
        customerName: null,
        projectName: null,
        projectIntro: null,
        note: null,
        promoterUuid: null,
      },
    };
  },
  mounted () { },
  methods: {
    show ({ type = "add", data }) {
      if (type == "revision") {
        this.form = this.$utils.deepClone(data);
        console.log(data)
      }
      this.type = type;
      this.dialogVisible = true;
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postDeal()
        } else {
          return false
        }
      })
    },
    closed () {
      this.form = {
        dealUuid: null,

        number: null,
        amount: null,
        customerName: null,
        projectName: null,
        projectIntro: null,
        note: null,
        promoterUuid: null,
      }
      this.$refs.form.resetFields()
    },
    // 添加
    async postDeal () {
      const api = {
        revision: {
          func: this.$api.putDeal,
          params: {
            ...this.form,
            dealUuid: this.form.uuid
          }
        },
        add: {
          func: this.$api.postDeal,
          params: {
            ...this.form,
          }
        }
      }
      const { status, data, info } = await api[this.type].func(api[this.type].params)
      if (status === 200) {
        this.$message({
          type: 'success',
          message: info
        })
        this.$emit('success', this.type)
        this.dialogVisible = false;
      } else {
        this.$message({
          type: 'error',
          message: info
        })
      }

    }
  },
};
 </script>
 <style lang='scss' scoped>
</style>